<template>
	<div class="customerDetail">
		<div class="headerBox">
			<el-button type="primary" plain class="addButtonClass" @click="backClick()">返回</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="rowList" style="width: 100%" v-loading="loading2">
				<el-table-column prop="" label="客户logo" min-width="1%">
					<template slot-scope="scope">
						<img :src="httpHost+scope.row.logo" alt="" class="logoList" v-if="scope.row.logo" />
						<!--<img src="../../assets/uploadImg.jpg" alt="" class="logoList" v-else/>-->
					</template>
				</el-table-column>
				<el-table-column prop="name" label="客户名称" min-width="1%">
				</el-table-column>
				<el-table-column prop="link_man" label="联系人" min-width="1%">
				</el-table-column>
				<el-table-column prop="link_tel" label="电话" min-width="1%">
				</el-table-column>
				<el-table-column prop="sign_time" label="签约时间" min-width="1%">
				</el-table-column>
				<el-table-column prop="expired_time" label="合同到期" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="运行状态" min-width="1%">
					<template slot-scope="scope">{{scope.row.status|statusFilter}}</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="headerBox2">
			下属客户
			<el-button type="primary" plain class="addButtonClass" @click="addClick()">新建客户</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" v-loading="loading">
				<el-table-column label="序 号" width="70">
					<template slot-scope="scope"><span style="padding-left: 6px;">{{(pageIndex-1)*pageSize+scope.$index+1}}</span></template>
				</el-table-column>
				<el-table-column prop="" label="客户logo" min-width="2%">
					<template slot-scope="scope">
						<img :src="httpHost+scope.row.logo" alt="" class="logoList" v-if="scope.row.logo" />
						<!--<img src="../../assets/uploadImg.jpg" alt="" class="logoList" v-else/>-->
					</template>
				</el-table-column>
				<el-table-column prop="name" label="客户名称" min-width="2%">
				</el-table-column>
				<el-table-column prop="link_man" label="联系人" min-width="2%">
				</el-table-column>
				<el-table-column prop="link_tel" label="电话" min-width="2%">
				</el-table-column>
				<el-table-column prop="sign_time" label="签约时间" min-width="2%">
				</el-table-column>
				<el-table-column prop="expired_time" label="合同到期" min-width="2%">
				</el-table-column>
				<el-table-column prop="" label="运行状态" min-width="2%">
					<template slot-scope="scope">{{scope.row.status|statusFilter}}</template>
				</el-table-column>
				<el-table-column prop="address" label="操作" min-width="4%">
					<template slot-scope="scope">
						<!--<a class="editClass" @click.prevent="engreySetClick(scope.row.id,scope.row)">能耗配置</a>-->
						<!--todo-->
						<!--<a class="editClass" @click.prevent="largeScreenClick(scope.row.id,scope.row,scope.row.name,b_id,rowObj)">大屏</a>-->
						<a class="editClass" @click.prevent="editClick(scope.row.id,scope.row)">编辑</a>
						<a class="editClass" @click.prevent="detailClick(scope.row.id,scope.row,scope.row.name,b_id,rowObj)">查看</a>
						<a class="editClass" @click.prevent="deleteClick(scope.row.id,scope.row.code)">删除</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20" :current-page.sync="pageIndex">
			</el-pagination>
		</div>
		<!--弹窗1新建客户-->
		<div class="specilDialog">
			<!--弹窗-->
			<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
				<el-form>
					<div class="itemClass">
						<el-form-item label="客户名称" label-width="25%">
							<el-input type="text" v-model="name" autocomplete="off"></el-input>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="编码" label-width="25%">
							<el-input type="text" v-model="code" autocomplete="off" @change="codeChange()"></el-input>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="联系人" label-width="25%">
							<el-input type="text" v-model="link_man" autocomplete="off"></el-input>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="电话" label-width="25%">
							<el-input type="text" v-model="link_tel" autocomplete="off"></el-input>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="签约时间" label-width="25%">
							<el-date-picker v-model="sign_time" type="date" placeholder="yy-mm-dd" value-format="yyyy-MM-dd" suffix-icon="close" style="width:100%">
							</el-date-picker>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="过期时间" label-width="25%">
							<el-date-picker v-model="expired_time" type="date" placeholder="yy-mm-dd" value-format="yyyy-MM-dd" suffix-icon="close" style="width:100%">
							</el-date-picker>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="超级管用户名" label-width="25%">
							<el-input type="text" v-model="username" autocomplete="off" @change="usernameChange()"></el-input>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="密码" label-width="25%">
							<el-input type="password" v-model="passwordValue" autocomplete="off" @change="passwordChange()"></el-input>
							<el-input type="password" v-model="password" autocomplete="off" style="display: none;"></el-input>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
					<div class="itemClass">
						<el-form-item label="确认密码" label-width="25%">
							<el-input type="password" v-model="confirmPasswordValue" autocomplete="off" @change="confirmPasswordChange()"></el-input>
							<el-input type="password" v-model="confirmPassword" autocomplete="off" style="display: none;"></el-input>
							<i class="iconfont icon-xinghao xinghaoClass"></i>
						</el-form-item>
					</div>
				</el-form>
				<div style="text-align: center;margin: 30px 0;">
					<el-radio v-model="status" label="开启">开启</el-radio>
					<el-radio v-model="status" label="关闭">关闭</el-radio>
				</div>
				<div style="text-align: center;">
					<div style="display: inline-block;">
						<img :src="httpHost+logo" alt="" v-if="logo" class="logoImg" />
						<img src="../../assets/uploadImg.jpg" alt="" v-else class="logoImg" />
					</div>
					<div style="display: inline-block;vertical-align: bottom;">
						<el-upload class="upload-demo" :action="http+'/zkep2/upload/upload'" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" list-type="picture" :data="personData" :on-change="onChange" :before-upload="beforeUpload" :show-file-list="false" accept=".png,.jpg">
							<button class="uploadClass"><i class="iconfont icon-shangchuan uploadIcon"></i>上传LOGO</button>
						</el-upload>
						<span class="titleClass">支持扩展名： jpg</span>
						<span class="titleClass">尺寸： 300*300</span>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
					<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
				</div>
			</el-dialog>
		</div>
		<!--弹窗2能耗配置-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible2" :width="dialogWidth2" :close-on-click-modal="false">
			<div style="margin:0 0 12px 7px">
				<el-checkbox v-model="checkedAll3" @change="changeClick()">全选/全不选</el-checkbox>
			</div>
			<div class="ergencyLi" v-for="item in deviceList" v-if="deviceList.length>0">
				<el-checkbox v-model="item.selected" @change="checkboxChange(item.selected,item.id,item.energy_id)">{{item.addr}}</el-checkbox>
			</div>
			<div v-if="deviceList.length==0">
				暂无设备数据！
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible2=false" class="cancle">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import httpHost from '../../../static/js/httpHost.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			this.firstPageIndex = this.$route.query.fI
			if(this.$route.query.sI) {
				this.pageIndex = this.$route.query.sI
			}
			if(typeof(this.pageIndex) != 'number') {
				this.pageIndex = Number(this.pageIndex)
			}
			this.b_id = this.$route.query.id
			this.getById(); //b列表
			this.httpHost = httpHost.httpHost
			/*当前年月*/
			var myDate = new Date();
			this.yearMonth = String(myDate.getFullYear()) + (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1)
			this.getList(); //获取列表(C)
			this.getC_mangerList(); //获取列表(C_manger)
			//this.getEnergy();//获取列表(能耗配置)
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
					this.dialogWidth2 = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
					this.dialogWidth2 = "70%"
				} else {
					this.dialogWidth = "36%"
					this.dialogWidth2 = "50%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
				this.dialogWidth2 = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
				this.dialogWidth2 = "70%"
			} else {
				this.dialogWidth = "36%"
				this.dialogWidth2 = "50%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				loading: false,
				loading2: false,
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				firstPageIndex: '', //第一个页面的当前页
				total: 0, //总条数
				tableData: [], //c列表
				c_mangerData: [], //c_manger列表
				dialogFormVisible: false,
				dialogFormVisible2: false,
				title: '', //弹窗标题
				b_id: '', //b_id
				rowList: [], //b列表
				/*表单1*/
				logo: '', //logo
				code: '', //编码
				name: '', //名称
				link_man: '', //联系人
				link_tel: '', //联系电话
				sign_time: '', //签约时间
				expired_time: '', //过期时间
				status: '开启', //状态
				username: '', //超级管理员用户名
				password: '', //密码
				passwordValue: '', //密码
				confirmPassword: '', //确认密码
				confirmPasswordValue: '', //确认密码
				dialogWidth: '36%', //dialog的宽度
				dialogWidth2: '50%', //dialog的宽度
				editId: null, //编辑的id(C)
				cEdit_id: null, //编辑的id(C_manger)
				notDo: false, //不执行开关
				listRow: {}, //编辑行数据
				/*上传*/
				personData: {}, //自定义上传参数
				fileList: [], //上传文件
				yearMonth: '', //当前年月
				/*表单2*/
				checked: true,
				deviceList: [], //设备列表
				c_ID: '', //c端的id
				rowObj: {},
				checkedAll3: false, //全选

			}
		},
		filters: {
			statusFilter: function(val) {
				if(val == "1") {
					return "关闭";
				}
				if(val == "2") {
					return "开启";
				}
			}
		},
		methods: {
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			//b列表
			getById() {
				var params = {}
				//console.log(params)
				let config = headers.headers(this.b_id)
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/b/' + this.b_id, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.rowList = []
						this.rowList.push(res.data)
					} else {
						this.rowList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//总条数
			getTotal() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					b_id: this.b_id,
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/c/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					b_id: this.b_id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/c/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false;
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.tableData = res.data
					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取列表(C_manger)
			getC_mangerList() {
				this.loading2 = true;
				var params = {
					pageSize: -1,
					pageIndex: 1,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/c_manager/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading2 = false;
					//console.log(res)
					if(res.data.length > 0) {
						this.c_mangerData = res.data
					} else {
						this.c_mangerData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			/*
			 * 上传
			 * */
			handleRemove(file, fileList) {},
			onChange(file, fileList) {},
			handlePreview() {},
			beforeUpload(file) {
				let fd = new FormData();
				fd.append('file', file); //传文件
				fd.append('path', '/mnt/xvdb/html/zkepA/storage/upload/' + this.yearMonth); //传其他参数
				var name = this.$uuid.v1()
				var index = file.name.lastIndexOf(".");
				var type = file.name.substring(index, file.name.length);
				fd.append('fileName', name + type); //传其他参数
				let config = headers.headers('uploadFile')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/upload/uploadFile',
					fd, {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res) {
						this.$message({
							type: 'success',
							message: '文件上传成功！'
						});
						var indexB = String(res.data).lastIndexOf("/storage");
						this.logo = (String(res.data).substring(indexB, String(res.data).length))
					} else {
						this.$message({
							type: 'error',
							message: '文件上传失败！'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//新增用户
			addClick() {
				this.title = "新建C端客户"
				this.dialogFormVisible = true
				this.emptyList()
			},
			//编辑的点击
			editClick(id, list) {
				this.dialogFormVisible = true
				this.title = '编辑C端客户'
				this.editId = id;
				this.logo = list.logo
				this.code = list.code
				this.name = list.name
				this.link_man = list.link_man
				this.link_tel = list.link_tel
				this.sign_time = list.sign_time
				this.expired_time = list.expired_time
				this.listRow = list
				for(var i=0;i<this.c_mangerData.length;i++){
					if(id == this.c_mangerData[i].c_id) {
						this.username = this.c_mangerData[i].username
						this.password = this.c_mangerData[i].password
						this.confirmPassword = this.c_mangerData[i].password
						this.cEdit_id = this.c_mangerData[i].id
						return
					}
				}
				/*this.c_mangerData.forEach(item => {
					if(id == item.c_id) {
						this.username = item.username
						this.password = item.password
						this.confirmPassword = item.password
						this.cEdit_id = item.id
					}
				})*/
			},
			//保存
			save() {
				var status;
				if(this.status == '开启') {
					status = 2
				} else if(this.status == '关闭') {
					status = 1
				}
				var manager_id = window.sessionStorage.getItem('id')
				/*创建时间的处理*/
				var timestamp = Date.parse(new Date());
				if(this.editId) { //编辑
					var params = {
						id: this.editId,
						b_id: this.b_id,
						logo: this.logo,
						code: this.code,
						name: this.name,
						link_man: this.link_man,
						link_tel: this.link_tel,
						sign_time: this.sign_time,
						expired_time: this.expired_time,
						status: status,
						version: 0
					}
				} else {
					var params = { //添加
						src: 1,
						manager_id: manager_id,
						b_id: this.b_id,
						logo: this.logo,
						code: this.code,
						name: this.name,
						link_man: this.link_man,
						link_tel: this.link_tel,
						sign_time: this.sign_time,
						expired_time: this.expired_time,
						create_time: timestamp,
						status: status,
						version: 0
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(!this.notDo) {
					if(this.logo && this.code && this.name && this.link_man && this.link_tel && this.sign_time && this.expired_time && this.username && this.password && this.confirmPassword) {
						if(this.confirmPassword == this.password) {
							axios.post(this.http + '/zkep2/c/save',
								qs.stringify(params), {
									headers: {
										'pass-token': pass_token,
										'time': timestamp
									}
								}).then(res => {
								//console.log(res)
								if(res.data.id) {
									var timestamp = Date.parse(new Date());
									if(this.editId) { //编辑
										var params = {
											id: this.cEdit_id,
											lev: 1,
											c_id: res.data.id,
											username: this.username,
											password: this.password,
											create_time: timestamp,
											status: 1,
											version: 0
										}
									} else {
										var params = { //添加
											lev: 1,
											c_id: res.data.id,
											username: this.username,
											password: this.password,
											create_time: timestamp,
											status: 1,
											version: 0
										}
									}
									//console.log(params)
									let config = headers.headers('save')
									var pass_token = config.pass_token
									var timestamp = config.timestamp
									if(this.username && this.password) {
										axios.post(this.http + '/zkep2/c_manager/save',
											qs.stringify(params), {
												headers: {
													'pass-token': pass_token,
													'time': timestamp
												}
											}).then(res => {
											//console.log(res)
											if(res.data.id) {
												this.dialogFormVisible = false
												this.getList();
												this.getC_mangerList();
												this.emptyList();
											} else {
												this.$message('操作失败！')
											}
										}).catch(err => {
											console.log(err)
										})
									} else {
										this.$message('请输入必填项！')
									}
								} else {
									this.$message('操作失败！')
								}
							}).catch(err => {
								console.log(err)
							})
						} else {
							this.confirmPasswordValue = ''
						}
					} else {
						this.$message('请输入必填项！')
					}
				} else {
					this.$message('请输入必填项！')
				}
			},
			//编码光标离开触发
			codeChange() {
				var params = {
					code: this.code
				}
				let config = headers.headers('getByCode')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/c/getByCode', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(this.editId && this.code == this.listRow.code) {
							this.notDo = false
							return
						}
						this.$message('该编码已存在,请重新输入编码！');
						this.notDo = true
						this.code = ''
					} else {
						this.notDo = false
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//用户名光标离开触发
			usernameChange() {
				var params = {
					username: this.username
				}
				let config = headers.headers('getByUsername')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/c_manager/getByUsername', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(this.editId && this.username == this.listRow.username) {
							this.notDo = false
							return
						}
						this.$message('该用户名已存在,请重新输入用户名！');
						this.notDo = true
						this.username = ''
					} else {
						this.notDo = false
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//密码的改变
			passwordChange() {
				this.password = md5(this.passwordValue + this.username + 'eq2') //md5格式
			},
			//确认密码的改变
			confirmPasswordChange() {
				if(this.confirmPasswordValue != this.passwordValue) {
					this.$message('确认密码与密码不符，请重新输入确认密码！');
					this.confirmPasswordValue = '';
				}
				this.confirmPassword = md5(this.confirmPasswordValue + this.username + 'eq2')
			},
			//删除
			deleteClick(id, code) {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: id,
					code: code + '_' + id,
					status: 0
				}
				//console.log(params)
				this.$confirm('确认要删除吗?', '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + '/zkep2/c/save', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getList();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//清空
			emptyList() {
				/*客户*/
				this.editId = ''
				this.logo = ''
				this.code = ''
				this.name = ''
				this.link_man = ''
				this.link_tel = ''
				this.sign_time = ''
				this.expired_time = ''
				/*客户管理员*/
				this.cEdit_id = ''
				this.username = ''
				this.password = ''
				this.confirmPassword = ''
				this.passwordValue = ''
				this.confirmPasswordValue = ''
			},
			//大屏
			largeScreenClick(id, list, name, b_id, rowList){
				this.$router.push({
					path: '/customer/largeScreen',
					name: 'LargeScreen',
					query: {
						c_id: id,
						name: name,
						b_id: b_id,
						fI: this.firstPageIndex,
						sI: this.pageIndex,
					}
				})
			},
			//能耗配置
			engreySetClick(id, val) {
				this.c_ID = id
				this.title = "能耗配置"
				this.dialogFormVisible2 = true
				//能耗配置列表(设备)
				var params = {
					c_id: id,
				}
				//console.log(params)
				let config = headers.headers('getDeviceList')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/energy/getDeviceList', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							if(item.selected == 0) {
								item.selected = false
							} else {
								item.selected = true
							}
						})
						this.deviceList = res.data
						var checkedArr = []
						this.deviceList.forEach(item => {
							if(item.selected == true) {
								checkedArr.push(item)
							}
						})
						if(checkedArr.length == this.deviceList.length) {
							this.checkedAll3 = true
						} else {
							this.checkedAll3 = false
						}
					} else {
						this.deviceList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//全选、全不选
			changeClick() {
				if(this.checkedAll3 == true) {
					this.deviceList.forEach(item => {
						item.selected = true
					})
				} else {
					this.deviceList.forEach(item => {
						item.selected = false
					})
				}
			},
			//复选框改变（能耗配置的保存）
			checkboxChange(val, device_id, id) {
				var checkedArr = []
				this.deviceList.forEach(item => {
					if(item.selected == true) {
						checkedArr.push(item)
					}
				})
				if(checkedArr.length == this.deviceList.length) {
					this.checkedAll3 = true
				} else {
					this.checkedAll3 = false
				}
				var manager_id = window.sessionStorage.getItem('id')
				var timestamp = Date.parse(new Date());
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(val == true) { //添加
					axios.post(this.http + '/zkep2/energy/save',
						qs.stringify({
							src: 1,
							c_id: this.c_ID,
							device_id: device_id,
							manager_id: manager_id,
							create_time: timestamp,
							status: 1,
							version: 0
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				} else { //删除
					axios.post(this.http + '/zkep2/energy/save',
						qs.stringify({
							id: id,
							status: 0,
						}), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {} else {
							this.$message('操作失败！');
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			//返回
			backClick() {
				this.$router.push({
					path: '/customer/customer',
					name: 'Customer',
					query: {
						fI: this.firstPageIndex
					}
				})
			},
			//查看
			detailClick(id, list, name, b_id, rowList) {
				this.$router.push({
					path: '/customer/customerC',
					name: 'CustomerC',
					query: {
						c_id: id,
						name: name,
						b_id: b_id,
						fI: this.firstPageIndex,
						sI: this.pageIndex,
					}
				})
			},
		}
	}
</script>

<style>
	.customerDetail {
		height: 100%;
		padding: 3.2% 12% 0 12%;
		position: relative;
	}
	
	.customerDetail .headerBox {
		position: relative;
		height: 30px;
		line-height: 30px;
		padding: 6px 30px;
		margin-bottom: 10px;
	}
	
	.customerDetail .headerBox2 {
		position: relative;
		height: 30px;
		line-height: 30px;
		padding: 6px 30px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		font-size: 13px;
		margin-bottom: 10px;
		margin-top: 50px;
	}
	
	.customerDetail .addButtonClass {
		position: absolute;
		top: 4px;
		right: 1%;
		padding: 10px 12px;
		font-size: 13px;
		width: 80px;
	}
	
	.customerDetail .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.customerDetail .editClass {
		color: #439DFD;
		margin-right: 6px;
		cursor: pointer;
	}
	/*表格*/
	
	.customerDetail .el-table th {
		color: #000;
	}
	
	.customerDetail .el-table {
		font-size: 12px;
	}
	
	.customerDetail .el-table th,
	.customerDetail .el-table td,
	.customerDetail .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.customerDetail .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: left;
		color: #999;
	}
	/*弹窗*/
	
	.customerDetail .el-dialog__title {
		color: #999;
	}
	
	.customerDetail .el-dialog__footer {
		text-align: center;
	}
	
	.customerDetail .pagination {
		text-align: center;
	}
	
	.customerDetail .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	
	.customerDetail .el-input__inner {
		height: 36px;
		line-height: 36px;
	}
	
	.customerDetail .el-form-item {
		margin-bottom: 12px;
	}
	/*单选框*/
	
	.customerDetail .el-radio__inner {
		border: 1px solid #439DFD;
	}
	
	.customerDetail .el-radio__input.is-checked+.el-radio__label {
		color: #606266;
	}
	
	.customerDetail .itemClass {
		position: relative;
	}
	
	.customerDetail .xinghaoClass {
		position: absolute;
		top: 0;
		right: -30px;
		font-size: 12px;
		color: #969896;
	}
	
	.customerDetail .uploadClass {
		background-color: #fff;
		border-radius: 4px;
		outline: none;
		padding: 4px 10px;
		color: #696969;
		border: 1px solid #ccc;
		margin-bottom: 4px;
	}
	
	.customerDetail .uploadIcon {
		color: #000;
		padding-right: 6px;
		font-size: 14px;
	}
	
	.customerDetail .titleClass {
		color: #808080;
		font-size: 13px;
	}
	
	.customerDetail .specilDialog .el-dialog__body {
		padding-right: 50px;
	}
	
	.customerDetail .el-input__prefix {
		display: none;
	}
	
	.customerDetail .ergencyLi {
		display: inline-block;
		padding-left: 6px;
		height: 32px;
		line-height: 32px;
		width: 22%;
		border: 1px solid #439DFD;
		background-color: #fff;
		border-radius: 3px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	/*复选框（原色）*/
	
	.customerDetail .el-checkbox {
		color: #439DFD;
	}
	
	.customerDetail .el-checkbox__label {
		display: inline-block;
		font-size: 12px;
	}
	
	.customerDetail .el-checkbox__inner {
		border: 1px solid #439DFD!important;
		background-color: #439DFD;
		border-radius: 0!important;
	}
	
	.customerDetail .el-checkbox__input.is-checked .el-checkbox__inner,
	.customerDetail .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #439DFD;
		border-color: #439DFD!important;
	}
	
	.customerDetail .logoImg {
		margin-left: -100px;
		margin-right: 20px;
		width: 105px;
		height: 95px;
	}
	
	.customerDetail .logoList {
		width: 30px;
		height: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Customer/CustomerDetail.vue